var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.482 1.976a6.747 6.747 0 1 1 9.542 9.542l-1.085 1.084a1.533 1.533 0 1 1-2.168-2.168l1.084-1.085a3.68 3.68 0 0 0-5.204-5.204L9.566 5.229a1.533 1.533 0 1 1-2.168-2.168l1.084-1.085Zm4.12 5.422c.6.599.6 1.57 0 2.168l-3.036 3.036a1.533 1.533 0 1 1-2.168-2.168l3.036-3.036a1.533 1.533 0 0 1 2.168 0Zm-7.481.108c.599.599.599 1.57 0 2.169l-.976.976a3.68 3.68 0 0 0 5.204 5.204l.976-.976a1.533 1.533 0 1 1 2.169 2.169l-.976.976a6.747 6.747 0 1 1-9.542-9.542l.976-.976a1.533 1.533 0 0 1 2.169 0Z",
    fill: "#102026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c94f21edfd7451e5dd782d0f730b628e.svg";
export { ForwardRef as ReactComponent };